// SF neighborhoods (DataSF "Analysis Neighborhoods", 41 areas), simplified to
// an outline ring + centroid. Used to make suggestions neighborhood-level
// instead of arbitrary map points. Data: src/lib/data/sf-neighborhoods.json.

import raw from './data/sf-neighborhoods.json';
import type { LatLng } from './types';

export interface Neighborhood {
  name: string;
  centroid: LatLng;
  /** Outer boundary as an ordered ring of points. */
  ring: LatLng[];
}

type RawHood = { name: string; c: [number, number]; ring: [number, number][] };

export const NEIGHBORHOODS: Neighborhood[] = (raw as RawHood[]).map((h) => ({
  name: h.name,
  centroid: { lat: h.c[0], lng: h.c[1] },
  ring: h.ring.map(([lat, lng]) => ({ lat, lng })),
}));
